export default {
  header: "My home page",
  view: "home",
  weather: {}
};
